export default {
  camelCaseToUnderscore(string) {
    return string.replace(/\.?([A-Z])/g, (_x, y) => `_${y.toLowerCase()}`);
  },

  underscoreToCamelCase(string) {
    return string.replace(/_([a-z])/g, g => g[1].toUpperCase());
  },
};
